export const checkViewMode = (mode: string = 'pdf'): boolean => {
  const { search } = window.location;
  const isMode = (search && search.indexOf(`mode=${mode}`) > -1) || false;
  return isMode;
};
